<script setup>
const props = defineProps({
    isDark: {
        type: Boolean,
        default: false,
    },
    strokeWidth: {
        type: Number,
        default: 1.5,
    },
});
</script>

<template>
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.4853 4.53523L3 13.0205"
            :stroke="isDark ? '#FFFFFF' : 'black'"
            :style="{ strokeWidth: strokeWidth }"
            stroke-linecap="round"
        />
        <path
            d="M6.53516 3.82812H11.442C11.8562 3.82812 12.192 4.16391 12.192 4.57812V9.48498"
            :stroke="isDark ? '#FFFFFF' : 'black'"
            :style="{ strokeWidth: strokeWidth }"
            stroke-linecap="round"
        />
    </svg>
</template>
